import { ReactComponent as LangSvg } from '@/asset/svg/lang.svg'
import { getLocalLang, LANGUAGES, setLocalLang } from '@/i18n'
import React from 'react'
import Select, { Option } from '../Select'
import './index.css'

const LangSelector: React.FC<PropType> = () => {
  const language = getLocalLang()

  const handleChange = (value: string) => {
    setLocalLang(value)
    // 刷新页面
    window.location.reload()
  }

  return (
    <div id="lang-selector" className="relative flex lang-selector">
      <Select
        value={language}
        onChange={handleChange}
        prefix={<LangSvg className="cus_menu-icon aspect-square h-[20px]" />}
        getPopupContainer={() => document.getElementById('lang-selector') as HTMLElement}
      >
        {LANGUAGES.map(lang => (
          <Option key={lang.value} value={lang.value}>
            {lang.label}
          </Option>
        ))}
      </Select>
    </div>
  )
}

interface PropType {}

export default LangSelector
